import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./features/auth/authSlice";
import roomReducer from "./features/room/roomSlice";
import chatReducer from "./features/chat/chatSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    room: roomReducer,
    chat: chatReducer,
  },

  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
